var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavZoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.961,
    height: 19.552,
    viewBox: "0 0 74 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.8521 75.3112V17.8217H61.407V75.3112H56.7182V0L17.0464 11.1231V27.0573H33.9932V75.3112H29.3044V31.7461H9.61242V75.3112H-0.00012207V80H73.7758V75.3112H68.8521ZM42.9087 48.5819V39.151H47.5975V48.5819H42.9087ZM47.5975 56.3749V65.8059H42.9087V56.3749H47.5975ZM42.9087 31.358V21.9271H47.5975V31.358H42.9087ZM17.1139 39.151H21.8027V48.5819H17.1139V39.151ZM17.1139 56.3749H21.8027V65.8059H17.1139V56.3749Z",
    fill: "#3E5943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavZoneIcon);
export default __webpack_public_path__ + "static/media/NavZoneIcon.f51ffe78a3e18634a29fe9984dc56855.svg";
export { ForwardRef as ReactComponent };